import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.clients.views.ContactView.';
  public static readonly saveContact = `${Id.prefix}saveContact`;
}

export class LangContactView {
  private constructor() {}
  public static saveContact(): string {
    return interpolate(Id.saveContact);
  }
}

export class ContactViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.saveContact, "Save {{glossary 'contact'}}", 'Button label for saving a contact');
  }
}
